import { Alert, Button } from 'antd';

export function DemoBanner() {
  return (
    <Alert
      type="info"
      showIcon
      banner
      message={
        <span>
          Bu bir <strong>demo ortamıdır</strong>. Veriler sentetiktir ve yazma işlemleri
          devre dışıdır.
        </span>
      }
      action={
        <Button
          type="primary"
          size="small"
          href="https://raporgor.com/kayit"
          target="_blank"
          rel="noopener noreferrer"
        >
          14 gün ücretsiz dene
        </Button>
      }
    />
  );
}
